import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef(({ className, sideOffset = 8, collisionPadding = 16, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      collisionPadding={collisionPadding}
      className={cn(
        "z-[10000] max-w-[240px] rounded-xl border border-violet-200/70 bg-gradient-to-br from-white via-violet-50/60 to-blue-50/60 px-3 py-2 text-xs font-medium text-slate-700 shadow-xl shadow-violet-500/10 backdrop-blur animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-tooltip-content-transform-origin]",
        className
      )}
      {...props} />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName = TooltipPrimitive.Content.displayName

const TooltipArrow = React.forwardRef(({ className, width = 18, height = 9, ...props }, ref) => (
  <TooltipPrimitive.Arrow ref={ref} width={width} height={height} className={cn("fill-current", className)} {...props} />
))
TooltipArrow.displayName = "TooltipArrow"

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, TooltipArrow }
